var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 86,
    viewBox: "0 0 74 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_657_43774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4149 13.683L42.4826 0.630886C42.0759 0.223688 41.5252 -0.00322832 40.9523 3.47104e-05H6.46615C2.89495 3.47104e-05 0 2.92181 0 6.52609V63.0853C0 66.6896 2.89495 69.6113 6.46615 69.6113H49.5738C53.145 69.6113 56.04 66.6896 56.04 63.0853V15.2275C56.0434 14.6493 55.8184 14.0936 55.4149 13.683V13.683ZM51.7292 63.0853C51.7292 64.2867 50.7643 65.2606 49.5738 65.2606H6.46615C5.27571 65.2606 4.31077 64.2867 4.31077 63.0853V6.52609C4.31077 5.32462 5.27571 4.35074 6.46615 4.35074H38.7969V13.0521C38.7969 15.455 40.7269 17.4029 43.1077 17.4029H51.7292V63.0853V63.0853Z",
    fill: "#363ED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4187 52.2085H43.1079V56.5592H47.4187V52.2085Z",
    fill: "#8D80E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4185 30.455H8.62158V34.8057H47.4185V30.455Z",
    fill: "#363ED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4185 41.3317H8.62158V45.6824H47.4185V41.3317Z",
    fill: "#363ED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.797 52.2085H8.62158V56.5592H38.797V52.2085Z",
    fill: "#363ED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8859 86C64.099 86 73.9998 76.0075 73.9998 63.6812C73.9998 51.3549 64.099 41.3624 51.8859 41.3624C39.6727 41.3624 29.772 51.3549 29.772 63.6812C29.772 76.0075 39.6727 86 51.8859 86Z",
    fill: "#FF4B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1036 73.8264C56.5037 73.8264 55.9163 73.5279 55.568 72.9806L45.2895 56.8349C44.7453 55.9799 44.9907 54.8415 45.838 54.2921C46.685 53.7428 47.8131 53.9906 48.3574 54.8457L58.6358 70.9914C59.18 71.8463 58.9346 72.9847 58.0874 73.5341C57.7824 73.7318 57.441 73.8264 57.1036 73.8264H57.1036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0375 73.8263C46.7001 73.8263 46.3587 73.7317 46.0538 73.534C45.2066 72.9846 44.9611 71.8462 45.5053 70.9913L55.7838 54.8456C56.3282 53.9906 57.4561 53.7429 58.3032 54.292C59.1504 54.8415 59.3959 55.9798 58.8516 56.8348L48.5732 72.9805C48.2248 73.5277 47.6373 73.8263 47.0375 73.8263H47.0375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_657_43774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadFailed);
export default __webpack_public_path__ + "static/media/icon-upload-failed.cad40cee3717dab79e307d43850a89e2.svg";
export { ForwardRef as ReactComponent };